import { render, staticRenderFns } from "./VendorProductAdd.vue?vue&type=template&id=3eecad46&"
import script from "./VendorProductAdd.vue?vue&type=script&lang=js&"
export * from "./VendorProductAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports